import React from "react";
import { withTranslation } from "react-i18next";
import { ContractRequestService, LocalStorageService, RepseService } from "../../../services";
import { RepseStatusView } from "../../views";
import { withRouter } from "react-router-dom";
import { NIL } from "uuid";

class RepseStatusAction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            showLoadingRequesting: false,
            showWarningRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '', // modal error

            companies: [],
            selectedCompany: null,
            companyFilterOptions: [],
            contractors: [],
            selectedContractor: null,
            contracts: [],
            selectedContract: null,
            documents: [],
            selectedDocument: null,
            documentUrl: "",

            yearFilterOptions: [],
            selectedYear: 2023,

            showContractScreen: false,
            editingContract: null
        };
    }

    token = {};
    email = "";
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    repseService = new RepseService(this.url);
    contractRequest = new ContractRequestService(this.url);

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleWarningRequesting = (value, message) => {
        this.setState(
            {
                showWarningRequesting: value,
                messageError: message,
            },
            () => {
                setTimeout(() => {
                    this.setState({ showWarningRequesting: false, message: "" });
                }, 5000);
            }
        );
    };

    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        });
    }

    // COMPANIES
    onYearFilterChange = async (year) => {
        this.toggleLoadingRequesting(true);
        try {
            await this.getCompanyData(year);
            this.toggleLoadingRequesting(false);
        } catch (e) {
            let messageError = e.message || this.props.t("repseStatusAction.error.data")
            if (e && e.response && e.response.data && e.response.data.statusCode && e.response.data.statusCode === 410) messageError = this.props.t("repseStatusAction.error.permissions")
            this.toggleErrorRequesting(true, messageError, 4000)
        }
    };

    onCompanyFilterChange = async (id) => {
        let selectedCompany = this.state.companies.find(c => id == c.id);

        this.setState({
            selectedCompany,
            contractors: selectedCompany.contractors
        });

        // this.props.history.replace({ pathname: `/repse-status-by-company/${id}`, search: `?year=${this.state.selectedYear}` })
    };

    getCompanyData = async (year) => {
        // let companies = dummy_companies;
        // let companyFilterOptions = companies.map(c => ({ id: c.id, name: c.name }));

        // const url = this.props.location.pathname;
        // const i = url.lastIndexOf("/");
        // const j = url.indexOf("?");

        // let urlId = -1;
        // if (i >= this.props.match.url.length) {
        //     urlId = url.substr(i + 1, j == -1 ? url.length : j);
        // }

        // let selectedCompanyIndex = companies.findIndex(company => company.id == urlId);
        // selectedCompanyIndex = selectedCompanyIndex == -1 ? 0 : selectedCompanyIndex;

        // this.setState({
        //     companies,
        //     companyFilterOptions,
        //     selectedYear: year,
        //     selectedCompany: companies[selectedCompanyIndex],
        //     contractors: companies[selectedCompanyIndex].contractors,
        //     error: ""
        // });

        // this.props.history.replace({ pathname: `/repse-status-by-company/${companies[selectedCompanyIndex].id}`, search: `?year=${year}` })

        let response = await this.repseService.getAllRepseCompanies(this.token, year);

        if (response.statusCode == 200) {
            let companies = response.data;

            if (!companies || Object.keys(companies).length === 0) {
                this.setState({
                    companies: [],
                    selectedYear: year,
                    selectedCompany: null,
                    contractors: [],
                });
                return;
            }

            let companyFilterOptions = companies.map(c => ({ id: c.id, name: c.name }));

            this.setState({
                companies,
                companyFilterOptions,
                selectedYear: year,
                selectedCompany: companies[0],
                contractors: companies[0].contractors,
                selectedContractor: null,
            });
        } else {
            throw new Error("Ocurrió un error al obtener los datos de las empresas.")
        }
    };

    // COMPANY
    getColorByCompanyStatus = (status) => {
        switch (status.toLowerCase()) {
            case "validado":
                return "green";
            case "pendiente":
                return "yellow";
            case "vencido":
                return "red";
            case "sin validar":
                return "gray";
            default:
                return "";
        }
    };

    // CONTRACTORS
    getColorByContractorStatus = (status) => {
        switch (status.toLowerCase()) {
            case "validado":
                return "green";
            case "pendiente":
                return "yellow";
            case "vencido":
                return "red";
            case "sin validar":
                return "gray";
            default:
                return "";
        }
    };

    onContractorSelected = async (contractor) => {
        if (!contractor.id) return;

        this.toggleLoadingRequesting(true);
        try {
            let response = await this.repseService.getRepseContractsByContractor(this.token, contractor.id, this.state.selectedYear);

            if (response.statusCode == 200) {
                this.setState({
                    selectedContractor: contractor,
                    contracts: response.data,
                    selectedContract: null,
                    documents: [],
                })
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo los contratos del proveedor.")
            }
            this.toggleLoadingRequesting(false);
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    createContractor = async (newContractorEmail, newContractorName, newContractLimitDate, newContractorNotes, contractorPersonType) => {
        try {
            const body = {
                email: newContractorEmail,
                emailCreator: this.email,
                name: newContractorName,
                limitDate: newContractLimitDate,
                notes: newContractorNotes,
                isRepse: true,
                onlyCreateContractor: true,
                companyId: this.state.selectedCompany.id,
                classifierId: 2,
                questionnaireId: NIL,
                contractorPersonType
            };

            this.toggleLoadingRequesting(true);
            let response = await this.contractRequest.createContractor(body, this.token);

            if (response.data.statusCode === 200) {
                this.toggleLoadingRequesting(false);
                this.toggleCompletedRequesting(true);

                setTimeout(() => {
                    this.toggleCompletedRequesting(false);
                }, 3000);
            } else if (response.data.statusCode === -2) {
                let msg = "El correo que intentas registrar para el proveedor ya ha sido utilizado anteriormente, por favor utilice otro correo."
                this.toggleLoadingRequesting(false);
                this.toggleErrorRequesting(true, msg, 4000, false);
            } else {
                this.toggleLoadingRequesting(false);
                this.toggleErrorRequesting(true, response.data.message, 4000, false);
            }
        } catch (e) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, "Hubo un problema registrando al proveedor.", 4000, false);
        }
    };

    onBackContractorScreen = () => {
        this.setState({
            selectedContractor: null,
            contracts: [],
            selectedContract: null,
            documents: [],
        });
    };

    // CONTRACTS
    getColorByContractStatus = (status) => {
        switch (status.toLowerCase()) {
            case "validado":
                return "green";
            case "pendiente":
                return "yellow";
            case "vencido":
                return "red";
            case "sin validar":
                return "gray";
            default:
                return "";
        }
    }

    onContractSelected = (contract) => {
        if (!contract.id) return;
        this.setState({
            selectedContract: contract,
            documents: contract.documents
        })
    }

    // DOCUMENTS
    getColorByDocumentStatus = (status) => {
        switch (parseInt(status.statusDocumentId)) {
            case +process.env.REACT_APP_STATUS_DOCUMENT_VALIDATED_ID:
                return "green";
            case +process.env.REACT_APP_STATUS_DOCUMENT_PENDING_ID:
                return "yellow";
            case +process.env.REACT_APP_STATUS_DOCUMENT_NO_VALIDATED_ID:
                return "red";
            case +process.env.REACT_APP_STATUS_DOCUMENT_NOT_NEEDED_ID:
                return "gray";
            default:
                return "";
        }
    }

    onDocumentSelected = async (document, monthIndex) => {
        this.toggleLoadingRequesting(true);
        try {
            let response = await this.repseService.getDocumentUrl(this.token, document.compliance[monthIndex].filePath)

            if (response.statusCode == 200) {
                this.setState({
                    selectedDocument: document,
                    documentUrl: response.data
                })
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo el documento.")
            }
            this.toggleLoadingRequesting(false);
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    async componentDidMount() {
        this.toggleLoadingScreen(true);
        try {
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            let user = this.localStorageService.getLocalStorageItem("user");
            this.email = user.userMetaData.userA3Cloud.email

            let years = [];
            let currentYear = new Date().getFullYear();
            for (let i = 2022; i <= currentYear; i++) {
                let yearStr = i.toString();
                years.push({
                    year: yearStr,
                    yearValue: yearStr,
                })
            }

            // const searchParams = new URLSearchParams(this.props.location.search);
            // const urlYear = searchParams.get("year");
            // currentYear = urlYear ? urlYear : currentYear;

            await this.getCompanyData(currentYear);

            this.setState({
                yearFilterOptions: years
            });
            this.toggleLoadingScreen(false);
        } catch (e) {
            let messageError = e.message || "Ocurrió un error al obtener los datos de la pantalla."
            if (e && e.response && e.response.data && e.response.data.statusCode && e.response.data.statusCode === 410) messageError = this.props.t("repseStatusAction.error.permissions")
            this.toggleErrorRequesting(true, messageError, 4000, true)
        }
    }

    toggleContractDetailsScreen = (showContractScreen, editingContract = null) => {
        this.setState({
            showContractScreen,
            editingContract
        })
    }

    render() {
        return (
            <RepseStatusView
                {...this.state}
                onYearFilterChange={this.onYearFilterChange}
                onCompanyFilterChange={this.onCompanyFilterChange}
                getColorByCompanyStatus={this.getColorByCompanyStatus}
                getColorByContractorStatus={this.getColorByContractorStatus}
                onContractorSelected={this.onContractorSelected}
                createContractor={this.createContractor}
                email={this.email}

                onBackContractorScreen={this.onBackContractorScreen}
                onContractSelected={this.onContractSelected}
                getColorByContractStatus={this.getColorByContractStatus}
                getColorByDocumentStatus={this.getColorByDocumentStatus}
                onDocumentSelected={this.onDocumentSelected}

                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleWarningRequesting={this.toggleWarningRequesting}

                toggleContractDetailsScreen={this.toggleContractDetailsScreen}
            />
        )
    }
}

export default withRouter(withTranslation()(RepseStatusAction));
